import { MessageView } from 'components/ui/Feedback';

import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { baseUrls } from '../../../utils/baseUrls.utils';
import { getChannelLink } from '../../../utils/link.utils';
import { EmailNeonSales } from '../../ui/EmailNeonSales';
import { isValidMongoId } from '../../../utils/id-validation.utils';

import { Box, Typography } from '@mui/material';

export const PremiumChannelSubscribeInterestConfirmation = () => {
    const history = useHistory();
    const { channelId } = useParams<{ channelId: string }>();
    const isValidChannelId = isValidMongoId(channelId);
    const isTrial = window.location.href.indexOf('?trial') > -1;

    if (!isValidChannelId) {
        return (
            <Box
                sx={(theme) => ({
                    display: 'flex',
                    height: 'calc(100vh - 212px)',
                    alignItems: 'center',
                    justifyContent: 'center',
                    [theme.breakpoints.down('sm')]: { pt: 4 },
                })}
            >
                <MessageView
                    styleName="primary"
                    size="large"
                    title="Channel not found"
                    primaryAction={{
                        label: 'Return to Neon Insights',
                        onClick: () => history.push(baseUrls.forYou),
                        styleName: 'primary',
                    }}
                />
            </Box>
        );
    }

    return (
        <Box
            sx={(theme) => ({
                display: 'flex',
                height: 'calc(100vh - 212px)',
                alignItems: 'center',
                justifyContent: 'center',
                [theme.breakpoints.down('sm')]: { pt: 4 },
            })}
        >
            <MessageView
                styleName={isTrial ? 'success' : 'primary'}
                title={
                    isTrial
                        ? 'Thank you for registering your interest in a free trial'
                        : 'Get in touch with Sales to discuss buying options'
                }
                primaryAction={{
                    label: isTrial ? 'View channel' : 'Return to insights',
                    onClick: () =>
                        history.push(
                            isTrial
                                ? getChannelLink(channelId)
                                : baseUrls.forYou
                        ),
                    styleName: isTrial ? 'success' : 'primary',
                }}
            >
                {isTrial ? (
                    <>
                        The Sales Team will be in touch with you shortly to set
                        up your access.
                    </>
                ) : (
                    <>
                        <Typography>
                            If you are interested in buying the subscription
                            now, please get in touch with our sales team to
                            discuss payment options.
                        </Typography>
                        <Typography>
                            If you need further assistance, you can email us at{' '}
                            <EmailNeonSales />
                        </Typography>
                    </>
                )}
            </MessageView>
        </Box>
    );
};
